import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router'


function AuditReportQms() {
    const { orgcode } = useParams()

    const [initialValues, setInitialValues] = useState({
        _id                         : "",
        orgCode                     : 0,
        nameoforg:"",
        reportNo:"",
        fileNo:"",
        address:"",
        siteofaddress:'NA',
        effectiveNoEmpToBeAudited:"",
        email:"",
        contactperson:"",
        telephone:"",
        nabcbcodeName:"",
        scope:"",
        nonapprequirements:"",
        typeofaudit:"",
        significantchanges:"",
        auditteam:"",
        dateofaudit:"",
        placeofaudit:"",
        briefaboutorg:"",
        anydeviationinauditplan:"",
        anysignificantissue:"",
        anyunresolved:"",
        verificationofeffectiveness:"",
        criteriaofaudit:"",
        objectiveofaudit:"",
        nameofprocess:"",
        processowner:"",
        details:"",
        summary:"",        
    })
    const options = [
        { key: 'Select', value: '-' },
        { key: 'Initial Audit', value: 'Initial Audit' },
        { key: 'Special Audit' , value: 'Special Audit' }
    ]
    const yesno = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No' , value: 'No' }
    ]
    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/rfq/get/listofcompaniesaccepted', {}))
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
            onSuccess(data) {
                console.log("Data",data.data.response)
                if (data.data.errorCode === 0) {
                    var tempInitialValues = data.data.response;
                    tempInitialValues.clientcode            = data.data.response.orgCode || "";
                    tempInitialValues.telephone             = data.data.response.telephone || "";
                    tempInitialValues.contactperson         = data.data.response.contactperson || "";
                    tempInitialValues.typeofaudit                        = data.data.response.typeofaudit || "";
                    tempInitialValues.effectiveNoEmpToBeAudited         = data.data.response.effectiveNoEmpToBeAudited || "";
                    tempInitialValues.email                  = data.data.response.email || "";
                    tempInitialValues.dateofaudit           = Date.parse(data.data.response.dateofaudit)|| null;
                    tempInitialValues.scopeofapplication    = data.data.response.scopeofapplication || "";
                    tempInitialValues.teamleader            = data.data.response.teamleader || "";
                    tempInitialValues.auditteam             = data.data.response.auditteam || "";
                    tempInitialValues.technicalexpert       = data.data.response.technicalexpert || "";
                    tempInitialValues.details               = data.data.response.details || "";
                    tempInitialValues.iafcode               = data.data.response.nabcbcodeNameName || "";
                    tempInitialValues.summary               = data.data.response.summary || "";
                    tempInitialValues.nonapprequirements    = data.data.response.nonapprequirements || "";
                    tempInitialValues.nabcbcodeName             = data.data.response.nabcbcodeNameName || "";
                    setInitialValues(tempInitialValues)
                } else {
                    var msg = 'Company - ' + data.data.errorMsg;
                    ToastInstance('Error', msg)
                }
            },
            onError(error) {
                console.log('Got error from backend', error)
                ToastInstance('Error', 'Get Company Details' + error)
            }
        })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
            mutation.mutate(values)
        }
     const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/auditreportqms', params), {
            onSuccess(data) {
                if (data.data.errorCode === 0) {
                    ToastInstance('Success', 'Audit Report QMS Added')
                    window.location.href="/admin/view/auditreportqms/"+ data.data.response.orgCode
    
                } else {
                    var msg = 'Audit Report - ' + data.data.errorMsg;
                    ToastInstance('Error', msg)
                }
            },
            onError(error) {
                console.log('Got error from backend', error)
                ToastInstance('Error', 'Subject' + error)
            }
        })
        const { data: stage2data, isLoading} = useQuery(
            'liststage2',
            () => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + orgcode, {}))
    
        useEffect(() => {
            if (stage2data && initialValues.orgCode === 0 ) {
                var tempData = stage2data.data.response
                tempData.dateofaudit = Date.parse(tempData.dateofaudit)
                setInitialValues(tempData)
    
            }
        }, [orgcode && !isLoading && initialValues.orgCode === 0])
        if (companyListLoading ) return <h1>Loading</h1>
        
        return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body" style={{ paddingLeft: "4rem",paddingTop:"1rem",paddingRight:"6rem" }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <form>
                                                        <div className="row">
                                                        <label htmlFor="staticEmail" className="col-sm-4">Name of the Organization </label>
                                                            <div className="col-sm-12">
                                                                {/* <FormikControl control='textarea' type="text" name='orgCode' /> */}
                                                                <FormikControl control='select' options={OrgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.currentTarget.value); }} type="text"  />
                                                            </div>                                                    
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Report No</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='reportNo' />
                                                            </div> 
                                                            </div> 

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">File No</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='fileNo' />
                                                            </div>                                             
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Address</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='address' />
                                                            </div>                                                   
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Site Address (If any)</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='siteofaddress' />
                                                            </div>   
                                                            </div>   

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">No. of Employees</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='effectiveNoEmpToBeAudited' />
                                                            </div>                                             
                                                        </div>


                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Email id</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='email' />
                                                            </div>   
                                                            </div>   

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Contact Person</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='contactperson' />
                                                            </div>                                             
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Telephone/Fax</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='telephone' />
                                                            </div>      
                                                                                                
                                                        </div>
                                                        <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-2">ANZSIC Code / NACE CODE</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='nabcbcodeName' />
                                                            </div>  
                                                            </div>   
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Scope</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='textarea' type="text" name='scope' />
                                                            </div>                                                   
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Non Applicable Requirements</label>
                                                            <div className="col-sm-12">
                                                                {/* <FormikControl control='checkbox' name='nonapprequirements'/> */}
                                                            </div> 
                                                            </div> 

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Type of Audit</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='select' name='typeofaudit' options={options} />
                                                            </div>                                          
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6">Significant Changes(if any),Since last audit that affects QMS</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='significantchanges' />
                                                            </div>  
                                                            </div>  

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Audit Team</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='auditteam' />
                                                            </div>                                          
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Date of Audit</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='date' type="text" name='dateofaudit' />
                                                            </div>   
                                                            </div>   

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Place of the Audit</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='placeofaudit' />
                                                            </div>                                          
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Brief about the organization</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='textarea' type="text" name='briefaboutorg' />
                                                            </div>                                                   
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6">Any Deviation in the Audit Plan and Reason(if any)</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='anydeviationinauditplan' />
                                                            </div> 
                                                            </div> 

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6">Any Significant issue impacting on the Audit Programme</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='anysignificantissue' />
                                                            </div>                                          
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6">Any unresolved issues(if identified)</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='anyunresolved' />
                                                            </div>  
                                                            </div>  

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-8">Verification of effectiveness of NC / Concerns closure of Stage 1 Audit(If any)</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='input' type="text" name='verificationofeffectiveness' />
                                                            </div>                                          
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2 mt-3">Criteria of Audit</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='textarea' type="text" name='criteriaofaudit' />
                                                            </div>                                                   
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Objective of Audit</label>
                                                            <div className="col-sm-12">
                                                                <FormikControl control='textarea' type="text" name='objectiveofaudit' />
                                                            </div>                                                   
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Name of the Process</label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='nameofprocess' />
                                                            </div> 
                                                                 
                                                            <label htmlFor="staticEmail" className="col-sm-2">Process Owner</label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='processowner' />
                                                            </div>                                          
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2 mt-3">Details</label>
                                                            <div className="col-sm-10">
                                                            <FormikControl control='ckEditor' name='details' className="form-control" data={initialValues.details} />
                                                            </div>                                                   
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2 mt-3">Summary</label>
                                                            <div className="col-sm-10">
                                                                {/* <FormikControl control='textarea' type="text" name='summary ' /> */}
                                                                <FormikControl control='ckEditor' name='summary' className="form-control" data={initialValues.summary} />
                                                            </div>                                                   
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right">Submit</button>
                            </div>

                        </div>
                    </div>
                    {/* <div className="row">
                    <div className="col-lg-11"></div>
                    <div className="col-lg-1" style={{ marginBottom: "10PX" }}>
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </div> */}
                </Form>
                }
            </Formik>
        </div>
    )
}

export default AuditReportQms
